<script setup lang="ts">
import { CircleAlert } from "lucide-vue-next"

import Badge from "@/components/custom/Badge.vue"
import { dateFormatter } from "@/lib/formatters"
import { formatPrice } from "@/lib/utils"
import type { Telework } from "@/types/serializers"

defineProps<Telework>()
</script>

<template>
  <div
    class="flex h-fit w-full flex-col gap-4 p-4"
    :class="[
      'bg-accent',
      {
        'bg-red-50/50': status === 'rejected',
        'bg-green-50/50': status === 'approved',
      },
    ]"
  >
    <div class="flex items-center justify-between">
      <p v-if="effective_from" class="text-sm">
        Nómina:
        {{
          dateFormatter(
            effective_from,
            { month: "long", day: undefined, year: "numeric" },
            "date",
          )
        }}
      </p>
      <p v-else class="text-sm" title="Fecha de solicitud">
        {{ dateFormatter(created_at, {}, "date") }}
      </p>
      <Badge :status="status" />
    </div>

    <div
      v-if="status == 'rejected' && reject_reason"
      class="text-destructive flex items-center gap-2"
    >
      <CircleAlert class="size-5 shrink-0" />
      <p>{{ reject_reason }}</p>
    </div>

    <p class="text-lg">{{ item_name }}</p>

    <div class="grid grid-cols-3">
      <div>
        <p class="text-xs">Fecha de compra</p>
        <p class="text-xl">
          {{ dateFormatter(purchase_date, {}, "date") }}
        </p>
      </div>

      <div>
        <p class="text-xs">Precio</p>
        <p class="text-xl">{{ formatPrice(price) }}</p>
      </div>

      <div v-if="approved_amount">
        <p class="text-xs">Importe solicitado</p>
        <p class="text-xl">
          {{ status === "rejected" ? "—" : formatPrice(approved_amount) }}
        </p>
      </div>
    </div>
  </div>
</template>
